import { Component, Input, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { LabourJobService } from '../labour-job.service';
import { UtilityService } from './../../services/utility.service';
import { FilterService } from '../../services/filter.service';
import { ClientService } from '../../services/client.service';
import * as _moment from 'moment';
import { LocationStrategy, Location } from '@angular/common';
import { CommentsComponent } from 'src/app/commons/comments/comments.component';
import { compileNgModule } from '@angular/compiler';


@Component({
  selector: 'labour-job-list',
  templateUrl: './labour-job-list.component.html',
  styleUrls: ['./labour-job-list.component.scss']
})
export class LabourJobListComponent implements OnInit {

  @ViewChildren('myCheckbox') private myCheckboxes: QueryList<any>;
  @Input('columnList') dynamicColumn
  @Input('isDisplay') displayView
  user = JSON.parse(localStorage.getItem('userRoles'))
  // displayedColumns: string[] = ['title', 'client', 'location', 'operative', 'completion', 'plannedhours', 'startdate', 'enddate', 'actions']
  // displayedColumns: string[] = ['title', 'client', 'operative', 'asset', 'startdate', 'enddate', 'startTime', 'endTime', 'actions']
  displayedColumns: string[] = ['title', 'projectcode', 'operative', 'asset', 'startdate', 'enddate', 'startTime', 'endTime', 'actions']
  dataSource: MatTableDataSource<any>;
  pageSize = 25;
  pageSizeOptions: number[] = [25, 50, 100];
  pageIndex = 0
  sort: MatSort;
  paginator: MatPaginator;
  jobList = []
  archivedJobsList = []
  filterActive = false
  loading = false
  multipleJobsDelete = []
  view = false
  searchText
  noDataMsg = {
    title: "No Jobs!",
    data: "You have not yet created any jobs"
  }
  showArchived = false
  isShow = true
  clientList = []
  clientListClone = []
  selectedClient = []
  clientSearchtext
  selectedDate
  isClearBtnShow = false

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public _route: Router,
    public _labourjobService: LabourJobService,
    public _utilityService: UtilityService,
    public _filter: FilterService,
    public _clientService: ClientService,
    public _activatedRoute: ActivatedRoute,
    private location: Location,
    private locationStrategy: LocationStrategy,
  ) {
    this.dataSource = new MatTableDataSource<any>(this.jobList);
  }

  ngOnInit(): void {
    this.getLabourjobList()
    if (this._route.url.includes('/dashboard') || this._route.url.includes('/asset')) {
      this.view = true;
      console.log("VIEW VALUE IS", this.view)
    }
    if (!this.view) this.getClientList()

    // query params will be updated from multi-job-list component, hence commented
    // this._activatedRoute.queryParams.subscribe((params) => {
    //   if (params && params.currentPage) {
    //     this.pageIndex = params.currentPage
    //     this.pageSize = params.pageOption
    //   }
    //   this.updateQueryParams()
    // })

  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes.dynamicColumn && changes.dynamicColumn.currentValue) this.displayedColumns = changes.dynamicColumn.currentValue
    if (changes.displayView && !changes.displayView.currentValue) this.isShow = changes.displayView.currentValue

  }



  // UTILITY

  createJob() {
    this._route.navigate(['/labour-job/create']);
  }


  updateData(jobs) {
    this.paginator.pageIndex = this.pageIndex
    this.dataSource = new MatTableDataSource(jobs);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'title': return item.jobTitle;
        case 'startdate': return new Date(item.startDate);
        case 'enddate': return new Date(item.endDate);
        case 'projectcode': return item.clients[0].projectCode.projectcode
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
  }

  filter(searchText) {
    // this.afterFilter = null
    this.filterActive = true;
    console.log('FILTER CALLED', searchText, this.showArchived);
    let jobData = this.showArchived ? this.archivedJobsList : this.jobList
    if (searchText === '') {
      this.filterActive = false;
      this.updateData(jobData);
      return;
    }
    let tempDataSource = this._filter.labourjobFilter(searchText, jobData, ['title', 'location', 'joboperative']);
    // console.log("TEMP DATA SOUCRE", tempDataSource);


    this.updateData(tempDataSource)
    if (tempDataSource.length <= 0) {
      this.noDataMsg = {
        title: "No Jobs!",
        data: "Sorry, no jobs matched your search"
      }
    } else this.filterActive = false
  }



  goToSingleJob(job) {
    console.log("SINGLE JOB DETAILS ", job);
    this._route.navigate(['/labour-job/view/' + job._id])
  }

  editJobModal(job) {
    this._route.navigate(['/labour-job/view/' + job._id], { queryParams: { currentTab: 1 } })
  }


  archivejob(event, job) {
    if (event.checked) this.multipleJobsDelete.push(job._id)
    else {
      this.multipleJobsDelete.splice(this.multipleJobsDelete.findIndex(a => a === job._id), 1)
    }
  }

  archiveChange(event: any) {
    console.log("WHEN ARCHIVED CHECK CHANGE", event, this.showArchived, this.archivedJobsList);
    this.filterActive = false
    if (this.selectedClient && this.selectedClient.length) this.clientFilter()
    else {
      if (this.showArchived) {
        console.log("CHECK THIS FUNCTION")
        this.updateData(this.archivedJobsList)
        this.noDataMsg = {
          title: "No Jobs!",
          data: "No Archived jobs added yet!"
        }
      }
      else {
        this.updateData(this.jobList)
        this.noDataMsg = {
          title: "No Jobs!",
          data: "You have not yet created any jobs"
        }
      }
    }
  }

  redirectiontoJob(jobId) {
    this._route.navigate(['/labour-job/view/' + jobId], { queryParams: { currentTab: 4 } })
  }

  // Client Filter for jobs

  clientFilter() {
    this.filterActive = false
    let jobData = this.showArchived ? this.archivedJobsList : this.jobList
    if (this.selectedClient && this.selectedClient.length) {
      const clientLength = this.selectedClient.length
      let clientJobs = []
      for (let i = 0; i < clientLength; i++) {
        const singleClientJob = jobData.filter((x) => {
          x.clients.some((y) => {
            if (y.client._id === this.selectedClient[i]._id) {
              clientJobs.push(x)
            }
          })
        })
      }
      if (clientJobs && !clientJobs.length) {
        this.filterActive = true

        if (this.showArchived) {
          this.noDataMsg = {
            title: "No Jobs!",
            data: "No Archived jobs added yet!"
          }
        } else {
          this.noDataMsg = {
            title: "No Jobs!",
            data: "You have not yet created any jobs"
          }
        }
      }
      this.updateData(clientJobs)
    } else {
      this.updateData(jobData)
    }
  }


  // Search form client list for client name
  clientSearch(text) {
    console.log("THIS IS SEARCH TEXT", text)
    let tempClients = this.clientListClone
    if (text === '') {
      this.clientList = this.clientListClone
      return;
    } else {
      let tempDataSource = this._filter.filter(text, tempClients, ['name']);
      console.log("TEMP DATA SOUCRE", tempDataSource);
      this.clientList = tempDataSource
      if (this.selectedClient && this.selectedClient.length) this.clientList = this.clientList.concat(this.selectedClient)
    }
  }

  datesSelected(event) {
    let jobData = this.showArchived ? this.archivedJobsList : this.jobList
    this.filterActive = true;
    if (event.startDate != null || event.endDate != null) {
      this.isClearBtnShow = true
      let tempDataSource = this._filter.dateFilterJobwise(jobData, event);
      this.updateData(tempDataSource)
      if (tempDataSource.length <= 0) {
        this.noDataMsg = {
          title: "No Jobs!",
          data: "Sorry, no jobs matched in the selected date range"
        }
      } else this.filterActive = false
    } else {
      this.filterActive = false;
      this.updateData(jobData);
    }
  }

  currentPage(event) {
    console.log("THIS IS THE EVENT OG PAGE", event)
    this.pageIndex = event.pageIndex
    this.pageSize = event.pageSize
    this.updateQueryParams()
  }



  updateQueryParams() {
    console.log("CURRENT PAGE OPTION", this.pageSize)
    console.log("CURRENT PAGE INDEX", this.pageIndex)
    this.location.replaceState(
      this._route.createUrlTree(
        [this.locationStrategy.path().split('?')[0]], // Get uri
        { relativeTo: this._activatedRoute, queryParams: { currentPage: this.pageIndex, pageOption: this.pageSize }, queryParamsHandling: 'merge' }).toString()
    );
    console.log("updated url in labour-job-list: ", this.locationStrategy.path());
  }


  addComent(job, index) {
    console.log("SINGLE JOB COMMENT", job, index)
    let obj = {
      jobId: job._id,
      remarks: job.remarks || [],
      isRemark: true
    }
    this._utilityService.commonDialogBoxOpen(CommentsComponent, obj, "100vh", "100vh").afterClosed().subscribe((commentAdded) => {
      console.log("COMMENT BOX OPEN", commentAdded)
      if (commentAdded == undefined) return
      else {
        this.jobList[index].remarks = commentAdded
      }
    })
  }

  getQueryParams() {
    this._activatedRoute.queryParams.subscribe((params) => {
      if (params && params.isDialog) {
        console.log("PARAMS DATA", params)
        const currentJob = this.jobList.find((x) => x._id === params.jobId)
        const jobIndex = this.jobList.findIndex((x) => x._id === params.jobId)
        console.log("THIS IS CURRENT JOB DATA", currentJob, jobIndex)
        if (currentJob != undefined) {
          this.addComent(currentJob, jobIndex)
        }
      }
    })

  }



  // API CALL


  // Get list of all labour jobs
  getLabourjobList() {
    this.loading = true
    this._labourjobService.getLabourjoblist().subscribe((jobList) => {
      console.log("JOB LIST OF LABOUR", jobList);
      this.jobList = jobList.displayJobs
      this.archivedJobsList = jobList.archivedJobs
      this.updateData(this.jobList)
      this.loading = false
      this.getQueryParams()
    }, err => {
      console.log("ERROR WHILE GET JOB LIST", err);
      this.loading = false
    })
  }

  // Remove Multiple jobs
  removeMultipleJobs() {
    console.log("REMOVED JOBS LIST", this.multipleJobsDelete);
    let tempData
    if (this.showArchived) tempData = 'Unarchive Jobs'
    else tempData = 'Archive Jobs'
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, tempData).afterClosed().subscribe((confirm) => {
      console.log("CONFIRMATION DATA", confirm);
      if (confirm == undefined) {
        this.manageCheckList()
        return confirm
      }
      if (confirm.confirm == "yes") {
        if (confirm.selectRadio == "Archive") {
          let obj = {
            isArchived: true,
            jobs: this.multipleJobsDelete
          }
          let msg = 'Jobs Archived Successfully!'
          this.archivedorDeleteJobs(obj, msg)
        }
        if (confirm.selectRadio == "Unarchive") {
          let obj = {
            isArchived: false,
            jobs: this.multipleJobsDelete
          }
          let msg = 'Jobs Unarchived Successfully!'
          this.archivedorDeleteJobs(obj, msg)
        }
        if (confirm.confirm == "yes" && confirm.selectRadio == "Delete") {
          console.log("delete if run ...........")
          let obj = {
            isDelete: true,
            jobs: this.multipleJobsDelete
          }
          let msg = 'Jobs Deleted Successfully!'
          this.archivedorDeleteJobs(obj, msg)
        }
      }
      else {
        this.manageCheckList()
      }
    })
  }


  manageCheckList() {
    let myCheckboxes = this.myCheckboxes.toArray();
    console.log("mycheckboxeslist==========>", myCheckboxes)
    let len = myCheckboxes.length;
    for (let i = 0; i < len; i++) {
      myCheckboxes[i].checked = false;
      console.log("my checked value=======>", myCheckboxes[i].checked)
    }
    this.multipleJobsDelete = []
  }

  // Archived or delete jobs based on selected value
  archivedorDeleteJobs(obj, msg) {
    this._labourjobService.deleteLabourjob(JSON.stringify(obj)).subscribe((deleted) => {
      console.log("JOBS DELETED DONE", deleted);
      this._utilityService.handleSnackBar({ msg: msg, button: "Ok" });
      this.multipleJobsDelete = []
      this.showArchived = false
      this.getLabourjobList()
    }, err => {
      console.log("Error while delete multiple jobs", err);
      this._utilityService.handleSnackBar({ msg: 'Something went wrong', button: "Ok" });
    })
  }

  // Duplicate the single job details
  duplicateJob(job) {
    let obj = {
      isDuplicate: true
    }
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, obj).afterClosed().subscribe((confirmation) => {
      if (confirmation == undefined) return
      if (confirmation == 'yes') {
        this._labourjobService.duplicateJob(job._id).subscribe((jobduplicate) => {
          this.jobList.push(jobduplicate)
          this.updateData(this.jobList)
          this._utilityService.handleSnackBar({ msg: 'Job Duplicate Successfully!', button: "Ok" });
        })
      } else {
        console.log("THIS IS FOR NO CONFIRMATION");
      }
    })
  }

  // Unlinked asset using jobId
  unlinkedAsset(jobId) {
    let obj = {
      linkedAsset: true
    }
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, obj).afterClosed().subscribe((confirmation) => {
      if (confirmation == undefined) return
      if (confirmation == 'yes') {
        let unlinkedAsset = {
          jobId: jobId
        }
        this._labourjobService.unlinkedAsset(unlinkedAsset).subscribe((jobduplicate) => {
          let index = this.jobList.findIndex((x) => x._id == jobId)
          this.jobList[index].linkedAsset = []
          this.updateData(this.jobList)
          this._utilityService.handleSnackBar({ msg: 'Asset Unlinked Successfully!', button: "Ok" });
        })
      } else {
        console.log("THIS IS FOR NO CONFIRMATION");
      }
    })
  }

  // Get Client list to display all clients
  getClientList() {
    this._clientService.getClients().subscribe((clients) => {
      console.log("ALL CLIENT LIST TO DISPLAY", clients)
      this.clientList = clients
      this.clientListClone = clients
    }, error => {
      console.log("ERROR WHILE GET CLIENT LIST", error)
    })
  }


}
